import { Segmented } from "antd";
import React from "react";
import EarningClaims from "./EarningClaims";
import ExpensesClaim from "./ExpencesClaim";

const Claims = () => {
    const [activeClaimType, setActiveClaimType] = React.useState<string>('Earning');

    const ClaimType = () => {

        return (<Segmented
            options={['Earning', 'Expenses']}
            value={activeClaimType}
            onChange={setActiveClaimType}
        />)
    }

    return (
        <div>

            {activeClaimType === 'Earning' && (
                <EarningClaims extraControles={[<ClaimType />]} />
            )}
            {activeClaimType === 'Expenses' && (
                <ExpensesClaim extraControles={[<ClaimType />]} />
            )}

        </div>
    )
}

export default Claims